module.exports = __webpack_public_path__ + "img/004ccfd5-7611-48be-bae1-8b06ca9714a6_base_resized.f9d4e634.jpg";